export const informationYouNeedBulletContent = [
    'Copies of any sales tax returns that you\'ve filed recently',
    'Usernames and passwords for all tax authority websites where you file electronically',
    'Bank account information, including the bank\'s name, addess, routing number, and account number',
];
export const thingsToDoBulletContent = (activeFlow) => [
    ...(activeFlow === 'returns' || activeFlow === null
        ? ['Complete a funding power of attorney so Avalara can withdraw money to pay for your returns']
        : []),
    'Select the returns Avalara should generate and set the filing frequency for each',
];
const finePrint = '*Sales tax calculation of transaction data requires a separate AvaTax subscription.';
export const mrsText = {
    accordions: [{
            accordionHeading: 'Why Avalara Returns',
            accordionSections: [{
                    infoBullets: [
                        'Let Avalara resolve sales tax notices on your behalf',
                        'Make a single payment for all of your sales tax returns – just set up the funding and we take care of the rest',
                        'File state and local sales tax returns on time, automatically',
                    ],
                    finePrint,
                }],
        }],
    setupText1: 'Set up your returns before the 20th of the month prior to when you want to file.',
    setupText2: 'For example, set up before March 20th to be ready to file in April.',
    thingsYouNeedToDoHeading: 'Things to do before Avalara can begin filing for you',
    additionalParagraphContent: [],
};
export const datesToRememberText = () => ({
    headingText: 'Avalara Returns filing dates to remember',
    bullets: [{
            dateRange: '5th through the 10th',
            text: 'Sign in to review and approve your returns',
            textSecondLine: 'On the 10th, returns are automatically approved after 5 p.m. PT',
        }, {
            dateRange: '11th through the 15th',
            text: 'Avalara withdraws money to fund the payments for your returns',
        }, {
            dateRange: '11th through the 20th',
            text: 'Avalara files your returns for you',
        }, {
            dateRange: 'Last day of the month',
            text: 'Sign in to view your completed returns',
        }],
});
